import { Link } from "@mui/material";
import { TFunction } from "i18next";
import RichText from "components/basic/richText";
import P from "pages/components/LegalParagraph";
import Bullets from "pages/components/LegalList";
import { PLACEHOLDER } from "pages/privacy/constants";
import { PolicySection } from "pages/privacy/content";

// Keep in step with VENDOR_TERMS in ev-server/src/constants.ts, which records
// the version each vendor accepted at sign-up.
export const TERMS_VERSION = 2;
export const TERMS_LAST_UPDATED = "2026-10-25";

export const termsSections = (t: TFunction<"legal">): PolicySection[] => [
  {
    id: "about",
    title: t("terms.about.title"),
    body: (
      <>
        <P>{t("terms.about.p1", PLACEHOLDER)}</P>
        <P>
          <RichText
            t={t}
            i18nKey="terms.about.p2"
            components={{
              link1: <Link href="/privacy" />,
              link2: <Link href="/vendor-agreement" />,
            }}
          />
        </P>
      </>
    ),
  },
  {
    id: "accounts",
    title: t("terms.accounts.title"),
    body: (
      <>
        <P>{t("terms.accounts.p1")}</P>
        <Bullets
          items={[
            t("terms.accounts.b1"),
            t("terms.accounts.b2"),
            t("terms.accounts.b3"),
          ]}
        />
        <P>{t("terms.accounts.p2")}</P>
      </>
    ),
  },
  {
    id: "marketplace",
    title: t("terms.marketplace.title"),
    body: (
      <>
        <P>{t("terms.marketplace.p1")}</P>
        <P>{t("terms.marketplace.p2")}</P>
      </>
    ),
  },
  {
    id: "vendors",
    title: t("terms.vendors.title"),
    body: (
      <>
        <P>{t("terms.vendors.p1")}</P>
        <P>{t("terms.vendors.p2")}</P>
      </>
    ),
  },
  {
    id: "acceptable-use",
    title: t("terms.acceptable_use.title"),
    body: (
      <>
        <P>{t("terms.acceptable_use.p1")}</P>
        <Bullets
          items={[
            t("terms.acceptable_use.b1"),
            t("terms.acceptable_use.b2"),
            t("terms.acceptable_use.b3"),
            t("terms.acceptable_use.b4"),
            t("terms.acceptable_use.b5"),
          ]}
        />
      </>
    ),
  },
  {
    id: "content",
    title: t("terms.content.title"),
    body: (
      <>
        <P>{t("terms.content.p1")}</P>
        <P>{t("terms.content.p2")}</P>
      </>
    ),
  },
  {
    id: "fees",
    title: t("terms.fees.title"),
    body: <P>{t("terms.fees.p1")}</P>,
  },
  {
    id: "disclaimers",
    title: t("terms.disclaimers.title"),
    body: <P>{t("terms.disclaimers.p1")}</P>,
  },
  {
    id: "liability",
    title: t("terms.liability.title"),
    body: <P>{t("terms.liability.p1")}</P>,
  },
  {
    id: "termination",
    title: t("terms.termination.title"),
    body: <P>{t("terms.termination.p1")}</P>,
  },
  {
    id: "changes",
    title: t("terms.changes.title"),
    body: <P>{t("terms.changes.p1")}</P>,
  },
  {
    id: "law",
    title: t("terms.law.title"),
    body: <P>{t("terms.law.p1")}</P>,
  },
  {
    id: "contact",
    title: t("terms.contact.title"),
    body: (
      <P>
        <RichText
          t={t}
          i18nKey="terms.contact.p1"
          values={PLACEHOLDER}
          components={{ link1: <Link href={`mailto:${PLACEHOLDER.email}`} /> }}
        />
      </P>
    ),
  },
];
